import { createAction, props } from '@ngrx/store';
import {FirmaZeitItem} from '@src/app/pages/Mitarbeiterverwaltung/firmaZeit.model';
import {FeiertagItem} from '@src/app/pages/Mitarbeiterverwaltung/feiertage.model';

export const editFeiertageStart = createAction('MITARBEITERVERWALTUNG::EDIT_FEIERTAGE_START',  props<{ item: FeiertagItem }>());
export const editFeiertageSucceeded = createAction('MITARBEITERVERWALTUNG::EDIT_FEIERTAGE_SUCCEEDED', props<{ item: FeiertagItem }>());
export const editFeiertageFailed = createAction('MITARBEITERVERWALTUNG::EDIT_FEIERTAGE_FAILED', props<{ error: Error }>());
